import {
  SET_CSRF_TOKEN,
  LOGIN_USER,
  LOGGED_IN_USER,
  PATCH_UPDATE_USER,
  SET_USER_INFO,
  CLEAR_LOGGED_IN_ERROR_MESSAGE,
  SIGNING_UP_USER,
  SIGN_UP_USER,
  SIGN_UP_ERROR,
  CLEAR_SIGN_UP_ERROR_MESSAGE,
  LOGOUT_USER,
  LOGGED_IN_ERROR,
  GOOGLE_LOGGED_IN_USER,
  FACEBOOK_LOGGED_IN_USER,
} from '../actions/actionTypes';

import { TOKEN } from '../constants';

const DEFAULT_STATE = {
  user: null,
  loading: false,
  loggedInErrorMessage: '',
  csrfToken: '',
  signUpError: '',
};

export const userReducer = (state = DEFAULT_STATE, action) => {
  const { user, jwt } = action?.payload || {};

  if (jwt) {
    localStorage.setItem(TOKEN, jwt);
  }
  switch (action.type) {
    case SET_CSRF_TOKEN:
      const { csrfToken } = action.payload;
      return {
        ...state,
        csrfToken,
      };

    case SIGNING_UP_USER:
      return {
        ...state,
        loading: true,
      };

    case SIGN_UP_USER:
      return {
        ...state,
        loading: false,
        user,
        jwt,
      };

    case SIGN_UP_ERROR:
      return {
        ...state,
        loading: false,
        signUpError: action?.payload,
      };

    case CLEAR_SIGN_UP_ERROR_MESSAGE:
      return {
        ...state,
        loading: false,
        signUpError: '',
      };

    case PATCH_UPDATE_USER:
      return {
        ...state,
        loading: true,
      };

    case LOGIN_USER:
      return {
        ...state,
        loading: true,
      };

    case SET_USER_INFO:
      return {
        ...state,
        user: action.payload,
        loading: false,
      };

    case LOGGED_IN_ERROR:
      return {
        ...state,
        loading: false,
        loggedInErrorMessage: action?.payload?.message,
      };

    case CLEAR_LOGGED_IN_ERROR_MESSAGE:
      return {
        ...state,
        loading: false,
        loggedInErrorMessage: '',
      };

    case LOGGED_IN_USER:
      return {
        ...state,
        loading: false,
        user,
        jwt,
      };

    case LOGOUT_USER:
      localStorage.removeItem(TOKEN);
      return {
        ...DEFAULT_STATE,
      };

    case GOOGLE_LOGGED_IN_USER:
      return {
        ...state,
        loading: false,
        user: action.payload,
        jwt: localStorage.getItem('token'),
      };
    case FACEBOOK_LOGGED_IN_USER:
      return {
        ...state,
        loading: false,
        user: action.payload,
        jwt: localStorage.getItem('token'),
      };
    default:
      return {
        ...state,
      };
  }
};
